/**
 * Slot Check Search (internal name: Universal Search) access.
 *
 * users.slotCheckSearchEnabled (Mongo, returned by Login + GetMe):
 *   1 or "1"  → the side menu item "Slot Check Search" and the header globe icon show
 *   0 / missing / anything else (including true) → both hidden, route redirects
 *
 * Same rule as ms-casino lib/universalSearch.ts isSlotCheckSearchEnabledValue
 * (the API also returns 403 when it is off).
 */
export function isSlotCheckSearchEnabled(value: unknown): boolean {
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') return value.trim() === '1';
  return false;
}

export const UNIVERSAL_SEARCH_ROUTE = '/universal-search';
